<template>
    <v-sheet class="fill-height" color="transparent">
        <v-lazy
            :v-model="user.projects"
            :options="{
                threshold: 0.5,
            }"
            class="fill-height"
        >
            <v-card
                :style="{
                    'background-color': '#fafafa',
                    'border-radius': '10px',
                }"
                flat
                class="ma-0 pa-0"
            >
                <v-row class="d-flex ma-0 pa-0">
                    <v-avatar class="ml-3 mt-3 pa-0" size="28">
                        <v-img
                            v-if="profilePicUrl"
                            :src="profilePicUrl"
                            :alt="user.name"
                        />
                        <v-icon v-else x-large color="#707070"
                            >mdi-account-circle</v-icon
                        >
                    </v-avatar>
                    <div class="ma-0 pa-2 pb-1">
                        <p class="ma-0 pa-0 font-weight-bold">
                            {{ user.name }}
                        </p>
                        <p class="ma-0 pa-0 mt-n1">
                            {{ user.role }}
                        </p>
                    </div>
                </v-row>
                <v-text-field
                    v-model="projectSearch"
                    backgroundColor="white"
                    class="black--text mx-2 my-1"
                    clearable
                    dense
                    filled
                    hide-details="auto"
                    placeholder="Search"
                    prepend-inner-icon="mdi-magnify"
                    rounded
                />
                <v-row class="flex-nowrap ma-0 pa-0">
                    <draggable
                        class="list-group overflow-y-auto px-2 py-0 ma-0"
                        :style="{ height: `${height - 68}px`, width: '100%' }"
                        v-model="user.projects"
                        group="projects"
                        :disabled="true"
                    >
                        <div
                            class="list-group-item py-0 mx-0 my-3 px-1"
                            v-for="(request, index) in filteredUserProjects"
                            :key="index"
                        >
                            <v-sheet
                                v-if="request"
                                min-height="94"
                                class="fill-height"
                                color="transparent"
                            >
                                <v-lazy
                                    :v-model="request"
                                    :options="{
                                        threshold: 0.5,
                                    }"
                                    class="fill-height"
                                >
                                    <ProjectUserCard
                                        :request="request"
                                        :users="users"
                                        :clients="clients"
                                        @openAssignBuyer="openAssignBuyer"
                                    />
                                </v-lazy>
                            </v-sheet>
                        </div>
                    </draggable>
                </v-row>
            </v-card>
        </v-lazy>
        <!--USERS-->
        <v-dialog persistent max-width="400px" v-model="selectBuyer">
            <AssignBuyer
                v-if="selectBuyer"
                :requestId="selectedRequest"
                :users="users"
                @close="closeAssignBuyer"
            />
        </v-dialog>
    </v-sheet>
</template>

<script>
import draggable from 'vuedraggable'
import { loadImage } from '@/helpers/imageHandler'
import { mapMutations } from 'vuex'

export default {
    name: 'ProjectUserColumn',
    components: {
        draggable,
        ProjectUserCard: () =>
            import('@/components/Projects/ProjectUserCard.vue'),
        AssignBuyer: () => import('@/components/Purchasing/AssignBuyer.vue'),
    },
    props: {
        user: Object,
        users: Array,
        height: Number,
        clients: Array,
    },
    data() {
        return {
            companyId: JSON.parse(localStorage.getItem('company')),
            folderUsersPictures: 'users_pictures',
            profilePicUrl: null,
            selectedTask: {},
            viewTaskDetails: false,
            selectBuyer: false,
            selectedRequest: undefined,
            projectSearch: '',
        }
    },
    computed: {
        userProjects() {
            return this.user.projects || []
        },
        filteredUserProjects() {
            if (!this.projectSearch) return this.userProjects

            const search = this.projectSearch.toLowerCase()

            return this.userProjects
                .filter(project => {
                    const name = String(project.name || '').toLowerCase()
                    const reference = String(
                        project.reference || ''
                    ).toLowerCase()
                    const clientName = String(
                        project.clientName || ''
                    ).toLowerCase()

                    return (
                        name.includes(search) ||
                        reference.includes(search) ||
                        clientName.includes(search)
                    )
                })
        },
    },
    async mounted() {
        try {
            if (this.user.picture) {
                const path = `${this.companyId}/${this.folderUsersPictures}`
                this.profilePicUrl = await loadImage(path, this.user.picture)
            }
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        openAssignBuyer(requestId) {
            this.selectedRequest = requestId
            this.selectBuyer = true
        },
        closeAssignBuyer() {
            this.selectBuyer = false
            this.selectedRequest = undefined
        },
    },
}
</script>
<style scoped>
.borderRounded {
    border-radius: 15px;
}

.underlineTag {
    text-decoration: underline #3277d1;
    font-weight: bold;
    font-size: 13px;
    color: #3277d1;
}
</style>
